import { render, staticRenderFns } from "./VisitorsCard.vue?vue&type=template&id=0b49e89c"
import script from "./VisitorsCard.vue?vue&type=script&lang=js"
export * from "./VisitorsCard.vue?vue&type=script&lang=js"
import style0 from "./VisitorsCard.vue?vue&type=style&index=0&id=0b49e89c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports